import { Notification } from "baseui/notification";
import LinkRate from "./LinkRate";
import { co2RateModelId } from "../../Energy/EnergyRates";
import { FormattedMessage, useIntl } from "react-intl";
import { useStyletron } from "baseui";

const NoRateReferenced = (props) => {
    const intl = useIntl();
    const [css, theme] = useStyletron()

    const rateText = props.rateModelId === co2RateModelId ? <b>CO2</b> : <b><FormattedMessage id="EnergyOverview.cost" defaultMessage={'Cost'}></FormattedMessage></b>;
    return (
        <>
            <Notification kind='warning' overrides={{
                Body: {
                    style: ({ $theme }) => ({
                        width: "auto"
                    })
                },
                InnerContainer: {
                    style: ({ $theme }) => ({
                        width: "100%"
                    })
                }
            }}>
                <div className={css({ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline' })}>
                    <div>{intl.formatMessage({ id: "ReferencedRate.RateIsMissingDescription", defaultMessage: "Link a {type} Rate to automatically get calculates Rates" }, { type: rateText })}</div>
                    {props.endEnhancer}
                </div>
                {props.children}
            </Notification>
        </>
    )
}

export default NoRateReferenced;